import L from "leaflet";
import { Marker, Popup } from "react-leaflet";
import { SOIL_SOURCE_URL, categoryLabel, formatSize } from "./soil";

// Small squares, so sites read differently from station dots and pollen
// diamonds; one shared icon for all ~700 markers
const ICON = L.divIcon({
  className: "aq-soil-anchor",
  html: '<span class="aq-soil"></span>',
  iconSize: [12, 12],
  iconAnchor: [6, 6],
  popupAnchor: [0, -6],
});

export const SoilSites = ({ sites }) =>
  sites.map((site) => {
    const size = formatSize(site);
    return (
      <Marker
        key={site.id}
        position={[site.lat, site.lon]}
        icon={ICON}
        title={site.name}
      >
        <Popup
          pane="popupPane"
          closeButton={false}
          minWidth={240}
          maxWidth={320}
        >
          <div className="aq-popup">
            <p className="aq-popup__level">
              <span className="aq-soil" aria-hidden="true" />
              {site.type ?? "Contaminated soil"}
            </p>
            <h3 className="aq-popup__name">{site.name}</h3>
            {site.description && (
              <p className="aq-popup__wind">{site.description}</p>
            )}
            <p className="aq-popup__wind">
              {categoryLabel(site.category)}
              {size && ` · ${size}`}
            </p>
            <p className="aq-popup__links">
              <a href={SOIL_SOURCE_URL} target="_blank" rel="noreferrer">
                UST register
              </a>
            </p>
          </div>
        </Popup>
      </Marker>
    );
  });
